






import Vue from 'vue';
import { defineComponent, inject, computed } from '@vue/composition-api';
import { WokDataGridConfiguration } from './helpers';

export default defineComponent({
    name: 'WokDataGridActions',

    setup() {
        const cfg = inject<WokDataGridConfiguration>('wokDataGridConfiguration');

        const columns = computed(() => cfg?.columns);

        const locale = computed(() => cfg?.locale);

        return {
            columns,
            locale
        }
    }
})
